import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Popup from 'reactjs-popup';
import { XLg } from 'react-bootstrap-icons';
import styles from './CSPConvertToRegularSKU.module.scss';
import Table from 'react-bootstrap/Table';
import { api } from '../../../../../../../../Utils/API';
import loadingGif from "../../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import { TEXT_SECONDARY } from '../../../../../../../../Utils/ColorsConfiguration';
import { CSPSuccessToast, CreationErrorToast, GenericErrorMessageToast } from '../../../../../../../../Utils/StaticMessages/ToastMessages';
import { MANAGE_AUTO_RENEW_STATUS_NCE } from '../../../../../../../../Utils/GlobalConstants';

const CSPConvertToRegularSKU = ({subscriptionTableAPIData, subscriptionId, planName, setSubscriptionTableAPIData, convertToRegularSkuPopupModalOpen, setConvertToRegularSkuPopupModalOpen,
  setToastSuccess, setToastError, setToastMessage, setActionCompletedRefreshSubscriptionTable, isNcePlan, setIsNcePlan, Logout, columnsSubscriptionTable, tableSubscriptionTable,
  setIsActionInProgress, setIsAutoRefreshEnabled, rowData, isFilterOrSearchActive
}) => {

  const [confirmLoadingFlag, setConfirmLoadingFlag] = useState(false);                                                        // loading state to be dispalyed while calling api
  const [showSaveButton, setShowSaveButton] = useState(true);                                                                // Show or hide save button for regular Sku conversion
  let ColumnNameForConvertToRegularSku = ["Plan Name","SKU ID", "Commitment Term (Billing Frequency)", "Quantity"];         // Columns of table for EST details and regular SKU details table
  

  // Header Authorization for General API's
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  // function makes N/w call to convert to regular SKU
  async function convertToRegularSku(subscriptionId) {
    setShowSaveButton(false);
    let requestBody = { 
      "subscriptionId": subscriptionId,
      "renewalStatus": "RENEW_EST_TO_REGULAR"             // setting est to regular flag
    }
    
    await api.post(MANAGE_AUTO_RENEW_STATUS_NCE, requestBody, config)
      .then(resp => {
                      if (resp.status >= 200 && resp.status < 300) {
                        setConvertToRegularSkuPopupModalOpen(false);
                        setSubscriptionTableAPIData(null);
                        setToastMessage(CSPSuccessToast);
                        setToastSuccess(true);
                        setTimeout(() => {
                            setToastSuccess(false);
                        }, 5000);
                        setActionCompletedRefreshSubscriptionTable(true);
                        if (!isFilterOrSearchActive) {
                            setIsAutoRefreshEnabled(true);
                            setIsActionInProgress(false);
                        }
                      } else {
                        setShowSaveButton(true);
                        setToastMessage(CreationErrorToast);
                        setToastError(true);
                        setTimeout(() => {
                           setToastError(false);
                        }, 5000);
                        setIsAutoRefreshEnabled(false);
                      }
                    })
                    .catch(error => {
                      setIsAutoRefreshEnabled(false);
                      if (error?.status == 401 || error?.response.status == 401) {
                          Logout();
                      }
                      setShowSaveButton(true);
                      setToastMessage(CreationErrorToast);
                      setToastError(true);
                      setTimeout(() => {
                          setToastError(false);
                      }, 5000);
                    })
  };

  return (
        <div>
          {/* Convert to Regular SKU Popup */}
          <Popup
            className={"custom-modal custom-modal-xl"}
            open={convertToRegularSkuPopupModalOpen}
            onClose={() => {
              setConvertToRegularSkuPopupModalOpen(false); setSubscriptionTableAPIData(null);
            }}
            closeOnDocumentClick={!confirmLoadingFlag}
            modal
            nested
          >
            {(close) => (
              <div className="modal">
                <>
                  <div className="header">
                    <h2>Convert to Regular SKU</h2>
                    <XLg
                      size={18}
                      className="cpointer text-strong"
                      onClick={() => {
                        if (!confirmLoadingFlag) {
                          close();
                          setIsActionInProgress(true);
                          setIsAutoRefreshEnabled(false);
                        }
                      }}
                      color={TEXT_SECONDARY}
                    />
                  </div>
                  <Container fluid>
                    <div className='mt-5 mb-4'>
                      {!subscriptionTableAPIData &&
                        <div className={styles["loading-plans"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading. . .</p></div>
                      }
                      { subscriptionTableAPIData &&
                        <div>
                            {/* EST SKU Table */}
                            <Col md={4}>
                              <label className='text-strong text-regular'>EST SKU</label>
                            </Col>
                            <div className='mt-4'>
                            <Table className={`${styles['csp-change-status-core-table']}`} responsive="md">
                              <thead className="sticky-top">
                                <tr>
                                  {ColumnNameForConvertToRegularSku.map(th => {
                                    return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : (th === "Plan Name") ? styles["min-width"] : ""}>{th}</th>)
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  <tr>
                                    <td>{subscriptionTableAPIData.planName}</td>
                                    <td>{subscriptionTableAPIData.planCode}</td>
                                    <td>{subscriptionTableAPIData.billingTerm}</td>
                                    <td className='text-right'>{subscriptionTableAPIData.quantity}</td>
                                  </tr>
                                }
                              </tbody>
                            </Table>
                            </div>
                            {/* Regular SKU Table */}
                            <Col md={4}>
                              <label className='text-strong text-regular'>Regular SKU</label>
                            </Col>
                            <div className='mt-4'>
                            <Table className={`${styles['csp-change-status-core-table']}`} responsive="md">
                              <thead className="sticky-top">
                                <tr>
                                  {ColumnNameForConvertToRegularSku.map(th => {
                                    return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : (th === "Plan Name") ? styles["min-width"] : ""}>{th}</th>)
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  <tr>
                                    <td>{subscriptionTableAPIData.regularPlanName}</td>
                                    <td>{subscriptionTableAPIData.planCode}</td>
                                    <td>{subscriptionTableAPIData.billingTerm}</td>
                                    <td className='text-right'>{subscriptionTableAPIData.quantity}</td>
                                  </tr>
                                }
                              </tbody>
                            </Table>
                            </div>
                        </div>
                      }
                      {subscriptionTableAPIData &&
                        <Row className='px-3 pb-0 mt-7'>
                          <Col md={12}>
                            <div className={`${styles['convert-btn']} btn-wrapper text-right`}>
                              {showSaveButton ? <>
                              <Button
                                  className="ml-3 mr-3 btn-border-light w-md-auto col-xs-12"
                                  variant="light"
                                  onClick={() => {
                                      setConvertToRegularSkuPopupModalOpen(false); setSubscriptionTableAPIData(null); setIsActionInProgress(true); setIsAutoRefreshEnabled(false);
                                  }}
                                  sx={{ mr: 1 }} > Cancel </Button>
                              <Button
                                className="px-4 mx-2"
                                onClick={() => {
                                    convertToRegularSku(subscriptionTableAPIData.subscriptionId);          // trigger conversion n/w call
                                }}>Save</Button></>
                              : 
                                <>
                                <Button
                                    className="ml-3 mr-3 btn-border-light w-md-auto col-xs-12"
                                    variant="light"
                                    disabled
                                    onClick={() => {
                                      setConvertToRegularSkuPopupModalOpen(false); setSubscriptionTableAPIData(null); setIsActionInProgress(true); setIsAutoRefreshEnabled(false);
                                    }}
                                    sx={{ mr: 1 }}> Cancel </Button>
                                <Button
                                    className="px-4 mx-2 btn-border-light w-md-auto col-xs-12"
                                    variant="light"
                                    disabled
                                  > Save</Button>
                                </>}
                            </div>
                          </Col>
                        </Row>
                      }
                    </div>
                  </Container>
                </>
              </div>
            )}
          </Popup>
        </div>
  )
}

export default CSPConvertToRegularSKU